import { useState, useEffect } from "react";
import { INicu } from "../types/interfaces/INicu";
import { INicusResponse } from "../types/interfaces/INicusResponse";

//This function fetches nicus from nicu controller.
export default function useNicus(): INicusResponse {
    const [data, setData] = useState<Array<INicu>>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    let url = "/api/controller/nicu/";

    useEffect(() => {
        const fetchNicus = async () => {
            try {
                const response = await fetch(url);
                if(response.ok) {
                    const nicuResponse = await response.json();
                    setData(nicuResponse.Nicus?.NicuList);
                }
                else {
                    setError(true);
                }
            }
            catch(e: any) {
                console.log(e);
                setError(true);
            }
            finally {
                setLoading(false);
            }
        };

        fetchNicus();

      }, [url]);

    return { data, loading, error };
}